import React from 'react';
import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { CompassIcon, HandshakeIcon, MoonIcon, LockIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { benefits } from '../data/content';
const iconMap = {
  compass: CompassIcon,
  handshake: HandshakeIcon,
  moon: MoonIcon,
  lock: LockIcon
};
export function WhyUs() {
  return <Box as="section" id="por-que" bg="ink.900" position="relative" pt={{
    base: 16,
    md: 28
  }} pb={{
    base: 16,
    md: 24
  }} mt={{
    md: '-4vw'
  }} sx={{
    clipPath: {
      base: 'none',
      md: 'polygon(0 0, 100% 4vw, 100% 100%, 0 100%)'
    }
  }} data-id="element-233" data-mp="1gjcuer77o8pd">
      <Box position="absolute" inset={0} opacity={0.45} pointerEvents="none" aria-hidden="true" bg="radial-gradient(45% 40% at 85% 15%, rgba(196,18,48,0.2) 0%, rgba(13,13,13,0) 70%), radial-gradient(40% 35% at 10% 80%, rgba(242,183,5,0.1) 0%, rgba(13,13,13,0) 70%)" data-id="element-234" data-mp="1liz811qybqyp" />

      <Box px={{
      base: 5,
      md: 10,
      xl: 16
    }} position="relative" data-id="element-235" data-mp="3ebupoorwwbft">
        <Reveal data-id="element-236" data-mp="3j9mrqbm9tdxq">
          <SectionHeading eyebrow="Nuestra forma de trabajar" title="¿Por qué consultarnos?" tone="dark" data-id="element-237" data-mp="3j93bczc9qxlt" />
        </Reveal>

        <Box position="relative" mt={{
        base: 12,
        md: 20
      }} maxW="62rem" mx="auto" data-id="element-238" data-mp="3naolicxf4xsb">
          {/* Timeline spine */}
          <Box position="absolute" top={0} bottom={0} left={{
          base: '1.35rem',
          md: '50%'
        }} w="2px" ml={{
          md: '-1px'
        }} bg="linear-gradient(180deg, rgba(242,183,5,0) 0%, rgba(242,183,5,0.75) 12%, rgba(242,183,5,0.75) 88%, rgba(242,183,5,0) 100%)" aria-hidden="true" data-id="element-239" data-mp="3s3hnwu5ezu18" />

          {benefits.map((benefit, index) => {
          const IconComponent = iconMap[benefit.icon];
          const isRight = index % 2 === 1;
          return <Flex key={benefit.title} position="relative" align="flex-start" justify={{
            md: isRight ? 'flex-end' : 'flex-start'
          }} pb={{
            base: 10,
            md: 14
          }} pl={{
            base: 14,
            md: 0
          }} data-id="element-240" data-mp="2gmhxy56jhrad" data-mpi={index}>
                {/* Node on the spine */}
                <Flex position="absolute" left={{
              base: 0,
              md: '50%'
            }} top={0} ml={{
              md: '-1.5rem'
            }} align="center" justify="center" w="3rem" h="3rem" borderRadius="full" bg="ink.900" border="2px solid" borderColor="gold.400" color="gold.300" boxShadow="0 0 0 6px rgba(13,13,13,1), 0 0 28px rgba(242,183,5,0.25)" zIndex={1} data-id="element-241" data-mp="3t06m88kvmwzv">
                  <IconComponent size={20} aria-hidden="true" data-id="element-242" data-mp="pftwag9kch97" />
                </Flex>

                <Reveal x={isRight ? 24 : -24} y={12} delay={index * 0.05} data-id="element-243" data-mp="kkehnm3qehbq">
                  <Box w={{
                base: '100%',
                md: '24rem'
              }} textAlign={{
                base: 'left',
                md: isRight ? 'left' : 'right'
              }} pl={{
                md: isRight ? 14 : 0
              }} pr={{
                md: isRight ? 0 : 14
              }} data-id="element-244" data-mp="145n6lybscof8">
                    <Text fontSize="xs" fontWeight={700} letterSpacing="0.3em" color="crimson.500" mb={2} data-id="element-245" data-mp="z4zef9btm1jf">
                      {String(index + 1).padStart(2, '0')}
                    </Text>
                    <Heading as="h3" fontSize={{
                  base: 'xl',
                  md: '1.9rem'
                }} color="cream.50" mb={3} data-id="element-246" data-mp="bh969bx85g0i">
                      {benefit.title}
                    </Heading>
                    <Text fontSize="sm" color="cream.200" opacity={0.8} data-id="element-247" data-mp="2eq64zktphhy">
                      {benefit.description}
                    </Text>
                  </Box>
                </Reveal>
              </Flex>;
        })}
        </Box>
      </Box>
    </Box>;
}